{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Brugerdefinerede Egenskaber",
    "HEADER_BTN_TXT": "Tilføj Tilpasset Attribut",
    "LOADING": "Henter brugerdefinerede attributter",
    "DESCRIPTION": "A custom attribute tracks additional details about your contacts or conversations—such as the subscription plan or the date of their first purchase. You can add different types of custom attributes, such as text, lists, or numbers, to capture the specific information you need.",
    "LEARN_MORE": "Learn more about custom attributes",
    "ATTRIBUTE_TYPES": {
      "TEXT": "Tekst",
      "NUMBER": "Tal",
      "LINK": "Link",
      "DATE": "Dato",
      "LIST": "Liste",
      "CHECKBOX": "Afkrydsningsfelt",
      "TEXT_AREA": "Tekstområde"
    },
    "ADD": {
      "TITLE": "Tilføj Tilpasset Attribut",
      "SUBMIT": "Opret",
      "CANCEL_BUTTON_TEXT": "Annuller",
      "FORM": {
        "NAME": {
          "LABEL": "Vis Navn",
          "PLACEHOLDER": "Angiv brugerdefineret attribut visningsnavn",
          "ERROR": "Navn er påkrævet"
        },
        "DESC": {
          "LABEL": "Beskrivelse",
          "PLACEHOLDER": "Angiv brugerdefineret attribut beskrivelse",
          "ERROR": "Beskrivelse er påkrævet"
        },
        "MODEL": {
          "LABEL": "Gælder for",
          "PLACEHOLDER": "Vælg venligst en",
          "ERROR": "Model er påkrævet"
        },
        "TYPE": {
          "LABEL": "Type",
          "PLACEHOLDER": "Vælg venligst en type",
          "ERROR": "Type er påkrævet",
          "LIST": {
            "LABEL": "Liste Værdier",
            "PLACEHOLDER": "Indtast venligst værdi og tryk på enter tasten",
            "ERROR": "Skal have mindst én værdi"
          }
        },
        "KEY": {
          "LABEL": "Nøgle",
          "PLACEHOLDER": "Angiv brugerdefineret attributnøgle",
          "ERROR": "Nøgle er påkrævet",
          "IN_VALID": "Ugyldig nøgle"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex Pattern",
          "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex Cue",
          "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Enable regex validation"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Brugerdefineret attribut blev tilføjet!",
        "ERROR_MESSAGE": "Could not create a Custom Attribute. Please try again later."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Slet",
      "API": {
        "SUCCESS_MESSAGE": "Brugerdefineret attribut slettet.",
        "ERROR_MESSAGE": "Kunne ikke slette den brugerdefinerede attribut. Prøv igen."
      },
      "CONFIRM": {
        "TITLE": "Er du sikker på du vil slette - {attributeName}",
        "PLACE_HOLDER": "Skriv venligst {attributeName} for at bekræfte",
        "MESSAGE": "Sletning vil fjerne den brugerdefinerede attribut",
        "YES": "Slet ",
        "NO": "Annuller"
      }
    },
    "EDIT": {
      "TITLE": "Rediger Brugerdefineret Attribut",
      "UPDATE_BUTTON_TEXT": "Opdater",
      "TYPE": {
        "LIST": {
          "LABEL": "Liste Værdier",
          "PLACEHOLDER": "Indtast værdier og tryk på enter tasten"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Brugerdefineret attribut opdateret",
        "ERROR_MESSAGE": "Der opstod en fejl under opdatering af brugerdefineret attribut. Prøv igen"
      }
    },
    "TABS": {
      "HEADER": "Brugerdefinerede Egenskaber",
      "CONVERSATION": "Samtale",
      "CONTACT": "Kontakt"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Navn",
        "DESCRIPTION": "Beskrivelse",
        "TYPE": "Type",
        "KEY": "Nøgle"
      },
      "BUTTONS": {
        "EDIT": "Rediger",
        "DELETE": "Slet"
      },
      "EMPTY_RESULT": {
        "404": "Der er ingen brugerdefinerede attributter oprettet",
        "NOT_FOUND": "Der er ingen brugerdefinerede attributter konfigureret"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex Pattern",
        "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex Cue",
        "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Enable regex validation"
      }
    }
  }
}
